import {
  getAuthBootstrapEvent,
  setAuthBootstrapEvent,
  waitForAuthBootstrapEvent,
} from './sessionStorage';

export const createAuthBootstrapOwnerId = (): string => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `auth-bootstrap-${Date.now()}`;
};

export const waitForCoordinatedAuthBootstrap = async (
  ownerId: string,
): Promise<'none' | 'succeeded' | 'failed' | 'timed_out'> => {
  return await waitForAuthBootstrapEvent({ ownerId });
};

export const markAuthBootstrapStarted = (ownerId: string): number => {
  const startedAt = Date.now();
  setAuthBootstrapEvent({
    state: 'started',
    ownerId,
    at: startedAt,
  });
  return startedAt;
};

export const markAuthBootstrapFinished = (ownerId: string, state: 'succeeded' | 'failed'): void => {
  setAuthBootstrapEvent({
    state,
    ownerId,
    at: Date.now(),
  });
};

export const clearOwnedAuthBootstrapEvent = (ownerId: string, startedAt: number): void => {
  const latestBootstrapEvent = getAuthBootstrapEvent();
  if (!latestBootstrapEvent) return;
  if (latestBootstrapEvent.ownerId !== ownerId) return;
  if (latestBootstrapEvent.at < startedAt) {
    setAuthBootstrapEvent(null);
  }
};
